<template>
  <div>
    <headerNav title="授权邀请" />
    
        <div class="s-mian-info"  @click="invite">
          <div class="s-mian-info-conf">
              <van-icon class="s-mian-info-conf-icon icon-left" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="daili" />
              <div>发展下级</div>
              <van-icon class="s-mian-info-conf-icon icon-right" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="you" />
          </div>
        </div>
        <div class="s-mian-info"  @click="refRecommend">
          <div class="s-mian-info-conf">
            <van-icon class="s-mian-info-conf-icon icon-left" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="daili" />
            <div>推荐代理</div>
            <van-icon class="s-mian-info-conf-icon icon-right" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="you" />
          </div>
        </div>
    <!-- <van-cell-group>
      <van-cell title="发展下级" icon="friends-o" is-link size="large" @click="invite">
        <van-icon name="friends-o" slot="icon" size="0.5rem" />
      </van-cell>
      <van-cell title="推荐代理" icon="friends-o" is-link size="large" @click="refRecommend">
        <van-icon name="friends-o" slot="icon" size="0.5rem" />
      </van-cell>
    </van-cell-group> -->
  </div>
</template>
<script>
export default {
  methods: {
    invite() {
      if (!this.abp.userInfo.memberLevelModel.isInvite) {
        this.$toast.fail("您没有发展下级的权限");
        return;
      }
      this.$router.push({
        path: "/authorizedinvitationsub",
        query: { registMethod: 0 },
      });
    },
    refRecommend() {
      if (!this.abp.userInfo.memberLevelModel.isRecommend) {
        this.$toast.fail("您没有推荐代理的权限");
        return;
      }
      this.$router.push({
        path: "/authorizedinvitationsub",
        query: { registMethod: 1 },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .s-mian-info
  {
    font-size: 20px;
    background-color: #fff;
    margin: 10px;
    border-radius: 8px;
    padding: 10px;
    position: relative;
    box-shadow: 1px 1px 4px #bdbdbd;
  }

  .s-mian-info-conf{
    position:relative;
    padding: 0 60px;
    line-height: 50px;
    font-size: 20px;
  }
  .s-mian-info-conf-icon{
    position:absolute;
    top:50%;
    transform: translate(0,-50%);
  }
  .icon-left{
    left:0;
  }
  .icon-right{
    right:0;
  }
</style>